export const appConfig = {
    locals:'zhCn', //默认语言
    languageList:[//语种
        { value: 'en', label: 'English' },
        { value: 'zhCn', label: '中文(简体)' },
        { value: 'zhHk', label: '中文(繁体)' },
    ],

}
